import {createReducer} from '@reduxjs/toolkit'
import {loadCalendarEvents, loadEventsPage, loadFeaturedEvent, setFilterType} from '../actions/events'
import {loadMembersForEvents} from '../actions/members'
import {Events} from '../types/state'

const defaultState: Events = {
  events: [],
  moreLoading: false,
  hasMore: false,
  filterType: null,
  latestRequestId: '',
}

export const events = createReducer(defaultState, builder =>
  builder
    .addCase(loadEventsPage.fulfilled, (state, {meta, payload}) => {
      if (state.latestRequestId !== meta.requestId) {
        return
      }

      const {offset} = meta.arg
      const reset = offset === 0

      state.events = reset ? payload.events : [...state.events, ...payload.events]
      state.hasMore = payload.hasMore
      state.moreLoading = false
    })
    .addCase(loadEventsPage.pending, (state, {meta}) => {
      const {offset} = meta.arg
      state.moreLoading = offset !== 0
      state.latestRequestId = meta.requestId
    })
    .addCase(loadEventsPage.rejected, state => {
      state.moreLoading = false
    })
    .addCase(loadFeaturedEvent.pending, (state, {meta}) => {
      state.latestRequestId = meta.requestId
    })
    .addCase(loadFeaturedEvent.fulfilled, (state, {meta, payload}) => {
      if (state.latestRequestId !== meta.requestId) {
        return
      }

      state.events = payload.featuredEvent ? [payload.featuredEvent] : []
    })
    .addCase(loadCalendarEvents.fulfilled, (state, {meta, payload}) => {
      if (payload) {
        const reset = meta.arg.fullReset
        const loadedEvents = reset ? [] : state.events
        const existingEventIds = loadedEvents.map(event => event.id)
        const newEvents = payload.events.filter(event => !existingEventIds.includes(event.id))

        state.events = [...loadedEvents, ...newEvents]
        state.hasMore = false
        state.moreLoading = false
      }
    })
    .addCase(setFilterType, (state, {payload}) => {
      state.filterType = payload
    })
    .addCase(loadMembersForEvents.fulfilled, (state, {payload}) => {
      state.events = state.events.map(event => ({
        ...event,
        ...(payload[event.id] || {}),
      }))
    }),
)
